export enum ProposalGroup {
  ExistingClients = 'Existing clients',
  NewClients = 'New clients',
}

export enum ProposalsTableColumnId {
  PROPOSAL_ID = 'proposal_id',
  PROPOSAL_NAME = 'name',
  PROPOSAL_CREATED_AT = 'created_at',
  PROPOSAL_CREATED_BY = 'created_by',
  PROPOSAL_GENERATED_AT = 'generated_at',
  PROPOSAL_FAILED_AT = 'failed_at',
  PROPOSAL_SUBMITTED_AT = 'submitted_at',
  PROPOSAL_CANCELED_AT = 'canceled_at',
  PROPOSAL_COMPLETED_AT = 'completed_at',
  PROPOSAL_ACCOUNTS = 'num_accounts',
  PROPOSAL_MARKET_VALUE = 'market_value',
  PROPOSAL_ORDERS = 'num_orders',
  PROPOSAL_FILLED_MARKET_VALUE = 'filled_market_value',
  PROPOSAL_FILLED_ORDERS = 'num_filled_orders',
  PROPOSAL_STATUS = 'proposal_status',
  PROPOSAL_FILL_PROGRESS = 'fill_progress',
  PROPOSAL_AVG_COUPON = 'average_coupon',
  PROPOSAL_AVG_YTW = 'average_ytw',
  PROPOSAL_AVG_DURATION = 'average_duration',
  PROPOSAL_AVG_MATURITY = 'average_maturity',
  PROPOSAL_USE_AS_TEMPLATE = 'use_as_template',
}

export enum ProposalDetailsOrdersTableColumnId {
  PROPOSAL_INSTRUMENT_ID = 'instrument_id',
  PROPOSAL_ORDER_ALLOCATIONS = 'allocations',
  PROPOSAL_ORDER_AMOUNT_AND_QUANTITY = 'amount_and_quantity',
  PROPOSAL_ORDER_BOND_SWAP_EVAL_PRICE = 'bond_swap_eval_price',
  PROPOSAL_ORDER_BOND_SWAP_LIMIT_PRICE = 'bond_swap_limit_price',
  PROPOSAL_ORDER_BOND_SWAP_PRICE_DIFFERENCE = 'bond_swap_price_diff',
  PROPOSAL_ORDER_CANCEL_ORDER = 'cancel_order',
  PROPOSAL_ORDER_CUSIP = 'cusip',
  PROPOSAL_ORDER_DESCRIPTION = 'description_short',
  PROPOSAL_ORDER_DURATION = 'duration',
  PROPOSAL_ORDER_EVAL_PRICE = 'instrument.price',
  PROPOSAL_ORDER_EVAL_YTW = 'eval_ytw',
  PROPOSAL_ORDER_EVAL_YTW_DIFFERENCE = 'eval_ytw_diff',
  PROPOSAL_ORDER_EXECUTION_PRICE = 'execution_price',
  PROPOSAL_ORDER_FILL_PROGRESS = 'fill_progress',
  PROPOSAL_ORDER_FILLED_AVG_PRICE = 'filled_avg_price',
  PROPOSAL_ORDER_FILLED_QUANTITY = 'filled_quantity',
  PROPOSAL_ORDER_ID = 'proposal_order_id',
  PROPOSAL_ORDER_ISIN = 'isin',
  PROPOSAL_ORDER_LIMIT_PRICE = 'limit_price',
  PROPOSAL_ORDER_LIMIT_YTM = 'limit_ytm',
  PROPOSAL_ORDER_LIMIT_YTW = 'limit_ytw',
  PROPOSAL_ORDER_MATURITY_DATE = 'maturity_date',
  PROPOSAL_ORDER_PAR_VALUE = 'par_value',
  PROPOSAL_ORDER_PRICE_AND_YTW = 'price_and_ytw',
  PROPOSAL_ORDER_PRICE_DIFFERENCE = 'price_diff',
  PROPOSAL_ORDER_TAX_EFFECTIVE_LIMIT_YTW = 'tax_effective_limit_ytw',
  PROPOSAL_ORDER_QUANTITY = 'quantity',
  PROPOSAL_ORDER_REMOVE_ORDER = 'remove_order',
  PROPOSAL_ORDER_SECTOR = 'sector',
  PROPOSAL_ORDER_SELECT = 'select',
  PROPOSAL_ORDER_SIDE = 'side',
  PROPOSAL_ORDER_SP_RATING = 'sp_rating',
  PROPOSAL_ORDER_STATUS = 'status',
}

export enum ProposalDetailsAccountsTableColumnId {
  PROPOSAL_MANAGEMENT_TYPE = 'management_type',
  PROPOSAL_ACCOUNT_DETAILS = 'account_details',
  PROPOSAL_ACCOUNT_NOTES = 'account_notes',
  PROPOSAL_ACCOUNT_MODEL = 'account_model',
  PROPOSAL_ACCOUNT_PROPOSED_TRADE_COUNT = 'proposed_trade_count',
  PROPOSAL_ACCOUNT_NEW_FI_WEIGHT = 'new_fi_weight',
  PROPOSAL_ACCOUNT_NEW_FI_WEIGHT_DIFFERENCE = 'new_fi_weight_diff',
  PROPOSAL_ACCOUNT_NEW_ACCOUNT_VALUE = 'new_account_value',
  PROPOSAL_ACCOUNT_NEW_ACCOUNT_VALUE_DIFFERENCE = 'new_account_value_diff',
  PROPOSAL_ACCOUNT_VIOLATIONS = 'violations',
  PROPOSAL_ACCOUNT_VIOLATIONS_DIFFERENCE = 'violations_diff',
  PROPOSAL_ACCOUNT_NEW_AVG_YTW = 'new_avg_ytw',
  PROPOSAL_ACCOUNT_NEW_AVG_YTW_DIFFERENCE = 'new_avg_ytw_diff',
  PROPOSAL_ACCOUNT_NEW_AVG_SP_RATING = 'new_avg_sp_rating',
  PROPOSAL_ACCOUNT_NEW_AVG_SP_RATING_DIFFERENCE = 'new_avg_sp_rating_diff',
  PROPOSAL_ACCOUNT_NEW_AVG_COUPON = 'new_avg_coupon',
  PROPOSAL_ACCOUNT_NEW_AVG_COUPON_DIFFERENCE = 'new_avg_coupon_diff',
  PROPOSAL_ACCOUNT_TOTAL_CASH = 'total_cash',
  PROPOSAL_ACCOUNT_TOTAL_CASH_DIFFERENCE = 'total_cash_diff',
  PROPOSAL_ACCOUNT_NEW_AVG_MATURITY = 'new_avg_maturity',
  PROPOSAL_ACCOUNT_NEW_AVG_MATURITY_DIFFERENCE = 'new_avg_maturity_diff',
  PROPOSAL_ACCOUNT_NEW_AVG_DURATION = 'new_avg_duration',
  PROPOSAL_ACCOUNT_NEW_AVG_DURATION_DIFFERENCE = 'new_avg_duration_diff',
  PROPOSAL_ACCOUNT_TRADES_PROGRESS = 'trades_progress',
}
